import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import { Container, Box, Grid } from "@material-ui/core";
import { LabelWithBackLine } from "../../../../../../components/LabelWithBackLine";
import { ProcessualForm } from './ProcessualForm';
import { ProcessualListing } from './ProcessualListing';

const ProcessualView = (props) => {
  let api = AppAPIService.getInstance();
  const [editingRecord, setEditingRecord] = useState(null);

  const handleSetEditingRecord = useCallback(async (record) => {
    console.log(record);
    const recordData = await api.makeHttpRequest({
      method: "GET",
      url: `/action/get-by-id/${record.id}`,
    });
    console.log("recordData", recordData);
    setEditingRecord({...recordData
    });
  }, [api]);

  return (
    <Container
      style={{
        boxShadow: "none",
        padding: 0,
        minHeight: "70vh",
      }}
      maxWidth="xl"
    >
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          style={{
            boxShadow: "none",
            width: "100%",
          }}
        >
          <LabelWithBackLine>Ações</LabelWithBackLine>
          <Box
            display="flex"
            alignItems="center"
            style={{
              padding: 0,
              marginTop: "35px",
              width: "100%",
              marginBottom: "35px",
            }}
            boxShadow="none"
          >
            <ProcessualForm
              editingRecord={editingRecord}
              handleSetEditingRecord={setEditingRecord}
            />
          </Box>
          <LabelWithBackLine>Ações Parametrizadas</LabelWithBackLine>
          <Container
            maxWidth="xl"
            style={{
              boxShadow: "none",
              padding: 0,
              marginTop: "20px",
            }}
          >
            <ProcessualListing
              setEditingRecord={handleSetEditingRecord}
            />
          </Container>
        </Grid>
      </Grid>
    </Container>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(ProcessualView);
